import { Fragment, useEffect, useState } from "react";
import DashboardCards from "../../Components/Dashboard/DashboardCards";
import DonationLogo from '../../Assets/images/donation.svg';
import TodaysDonationLogo from '../../Assets/images/today-donation.svg';
import JobBoard from "./JobBoard";
import { DonorService } from "../../Services/Donor.Service";
import TokenService from "../../Services/Token.service";
import { useNavigate } from "react-router-dom";
function DonorHome() {
    const [upcomingDonations, setUpcomingDonations] = useState(null);
    const getUpcomingDonationsCount = async ()=>{
        try{

            const donorId= TokenService.getUserId();
            if(donorId){

                const result = await DonorService.getUpcomingDonationsCount( {donor_id : donorId}); 
                if(result.success){ 
                    setUpcomingDonations(result.count);
                }
                else{
                    console.log("Error while getting upcoming donation count");
                }
            }
        }
        catch{ 
            console.log("Error while getting upcoming donation count");
        }
    }
    useEffect(()=>{
        getUpcomingDonationsCount();
    },[]);
    const navigate = useNavigate();

    const handleNavigation = ()=>{
        //navigate to upcoming donations.
        navigate('/donor/upcoming-donations');
    }
    return (
        <>
            <Fragment>
                <div className="el-middle-wrapper">
                    <div className="el-middle-section">
                        <div className="el-middle-top">
                        <DashboardCards src={DonationLogo} label="Upcoming Donation(s)" count={upcomingDonations}  onClick={handleNavigation}/>
                        </div>
                         <JobBoard  onUpdateDonations={getUpcomingDonationsCount} />
                    </div>
                </div>
            </Fragment>
        </>
    );
}

export default DonorHome;